// components/TextToSpeech.js
import api from '../utils/api';
import { base64ToBlob } from './util';

const voices = ["alloy", "echo", "fable", "onyx", "nova", "shimmer"];

const getRandomVoice = () => {
  const randomIndex = Math.floor(Math.random() * voices.length);
  return voices[randomIndex];
};

const playTextToSpeech = async (text, voice = 'nova') => {
  const selectedVoice = voice === 'random' ? getRandomVoice() : voice;

  try {
    const response = await api.post('/callAI', {
      provider: 'openai',
      prompt: text,
      task: 'tts',
      metadata: { voice: selectedVoice }
    });

    if (response.status === 200) {
      // Convert base64 to blob
      const audioBase64 = response.data.audio_base64 || response.data.result?.audio_base64;
      const audioBlob = base64ToBlob(audioBase64, 'audio/wav');
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.play();

      console.log("selected Voice: ", selectedVoice);

      // Cleanup after audio ends
      audio.onended = () => {
        URL.revokeObjectURL(audioUrl);
      };
    } else {
      console.error("Failed to fetch audio:", response.status, response.statusText);
    }
  } catch (error) {
    console.error("Error fetching audio:", error);
  }
};

export default playTextToSpeech;
